const React = require('react');
const PropTypes = require('prop-types');
const ChoroplethWorld = require('components/charts/ChoroplethWorld/ChoroplethWorld');


const CountryExposureChart = ({ countrySelected, data }) => (
    <ChoroplethWorld
        data={data}
        countryKey="type"
        countrySelected={countrySelected}
    />
);


CountryExposureChart.defaultProps = {
    countrySelected: false,
};


CountryExposureChart.propTypes = {
    countrySelected: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    data: PropTypes.array.isRequired,
};


module.exports = CountryExposureChart;
